"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dashboard = require("@/api/dashboard");
var _index = _interopRequireDefault(require("@/components/echarts/index"));
var _permission = require("@/utils/permission");
var _index2 = _interopRequireDefault(require("@/components/echartsNew/index"));
var _vueCountTo = _interopRequireDefault(require("vue-count-to"));
var customerOrderApi = _interopRequireWildcard(require("@/api/customerOrderApi.js"));
var _amount = require("@/utils/amount");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
/** 福豆统计四宫格默认项：接口未返回或加载前占位，避免布局跳动 */
function getDefaultFukaStatsList() {
  return [{
    name: '总福豆数',
    integral: 0
  }, {
    name: '使用福豆数',
    integral: 0
  }, {
    name: '剩余福豆数',
    integral: 0
  }, {
    name: '使用福豆率',
    integral: 0
  }];
}
var _default = exports.default = {
  components: {
    echartsFrom: _index.default,
    echartsNew: _index2.default,
    CountTo: _vueCountTo.default
  },
  data: function data() {
    return {
      projectId: null,
      customerId: null,
      sendType: null,
      appId: null,
      dateRange: null,
      proJectList: [],
      customerList: [],
      aotuList: [],
      optionData: {},
      style: {
        height: '400px'
      },
      businessList: getDefaultFukaStatsList(),
      statsLoading: false,
      // 四宫格加载状态
      chartLoading: false,
      // 图表加载状态
      infoList: null,
      visitDate: 'last30',
      series: [],
      xAxis: [],
      info: {},
      legendData: [],
      yAxisData: [],
      exportLoading: false,
      isExporting: false,
      // 是否正在导出
      exportProgress: 0,
      // 导出进度（浮点数，用于计算）
      exportProgressInteger: 0,
      // 导出进度（整数，用于显示）
      customColors: [{
        color: '#f56c6c',
        percentage: 20
      }, {
        color: '#e6a23c',
        percentage: 40
      }, {
        color: '#5cb87a',
        percentage: 60
      }, {
        color: '#1989fa',
        percentage: 80
      }],
      colorList: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
      sendTypeOptions: [{
        value: 1,
        label: '测试卡'
      }, {
        value: 2,
        label: '体验卡'
      }, {
        value: 3,
        label: '内部员工卡'
      }, {
        value: 4,
        label: '出单卡'
      }, {
        value: 5,
        label: '赠送'
      }, {
        value: 6,
        label: '其他'
      }, {
        value: 7,
        label: '客户充值'
      }],
      shouldHideChart: false // 是否隐藏图表（customerId 为 46 时隐藏）
    };
  },
  mounted: function mounted() {
    var _this = this;
    // 判断是否需要隐藏图表（customerId 为 46 时隐藏）
    if (this.defaultCustomerId === 46) {
      this.shouldHideChart = true;
    }
    this.handleRquestApi();
    this.getChannel();
    this.getUserViewSelect();
    this.handeGetAllCustomer();
    this.handleCompanyappAutoListApi();
    // 默认四宫格立即展示，不依赖接口返回
    this.$nextTick(function () {
      _this.initAnimation();
    });
  },
  watch: {
    // 监听defaultCustomerId变化
    defaultCustomerId: {
      handler: function handler(newVal) {
        console.log("newVal", newVal);
        if (newVal) {
          this.setDefaultCustomer();
        }
        if (newVal && this.aotuList.length > 0) {
          this.setDefaultAppId();
        }
      },
      immediate: true
    },
    // 监听aotuList变化
    aotuList: {
      handler: function handler(newVal) {
        if (newVal.length > 0 && this.defaultCustomerId) {
          this.setDefaultAppId();
        }
      },
      deep: true
    }
  },
  computed: {
    // 将进度转换为整数，使用缓存减少计算
    exportProgressInteger: function exportProgressInteger() {
      var rounded = Math.round(this.exportProgress);
      return rounded;
    }
  },
  methods: {
    checkPermi: _permission.checkPermi,
    getStatSuffix: function getStatSuffix(item) {
      if (!item || !item.name) return '元';
      return item.name.includes('率') ? '%' : '元';
    },
    formatYuan: function formatYuan(value, options) {
      return (0, _amount.formatToYuan)(value, options);
    },
    formatBarLabel: function formatBarLabel(data) {
      if (!data) return '';
      return "".concat(this.formatYuan(data.value), " (").concat(data.percent, "%)");
    },
    formatBarTooltip: function formatBarTooltip(params, totalValue) {
      if (!Array.isArray(params) || !params.length) return '';
      var item = params[0];
      var percent = totalValue ? (item.value / totalValue * 100).toFixed(2) : '0.00';
      return "".concat(item.name, "<br/>").concat(this.formatYuan(item.value), " (").concat(percent, "%)");
    },
    handleChange: function handleChange() {
      this.handleRquestApi();
      this.getChannel();
    },
    /** 将接口结果规范为固定 4 项，不足或异常时用默认占位 */normalizeFukaStatsList: function normalizeFukaStatsList(res) {
      var defaults = getDefaultFukaStatsList();
      var list = [];
      if (Array.isArray(res)) {
        list = res;
      } else if (res && _typeof(res) === 'object' && Array.isArray(res.list)) {
        list = res.list;
      }
      if (!list.length) {
        return defaults.map(function (d) {
          return _objectSpread({}, d);
        });
      }
      return defaults.map(function (d, i) {
        var item = list[i];
        if (!item || _typeof(item) !== 'object') {
          return _objectSpread({}, d);
        }
        var integral = item.integral;
        return {
          name: item.name != null && String(item.name) !== '' ? item.name : d.name,
          integral: integral != null && integral !== '' ? Number(integral) : 0
        };
      });
    },
    handleRquestApi: function handleRquestApi() {
      var _this2 = this;
      this.statsLoading = true;
      (0, _dashboard.fucardIntegralData)(this.getQueryParams()).then(function (res) {
        _this2.businessList = _this2.normalizeFukaStatsList(res);
        _this2.$nextTick(function () {
          _this2.initAnimation();
        });
      }).catch(function () {
        _this2.businessList = getDefaultFukaStatsList();
        _this2.$nextTick(function () {
          _this2.initAnimation();
        });
      }).finally(function () {
        _this2.statsLoading = false;
      });
    },
    // 获取查询参数
    getQueryParams: function getQueryParams() {
      var params = {
        appId: this.appId,
        customerId: this.customerId,
        projectId: this.projectId,
        sendType: this.sendType
      };

      // 添加日期范围参数
      if (this.dateRange && this.dateRange.length === 2) {
        params.startDate = this.dateRange[0];
        params.endDate = this.dateRange[1];
      }
      return params;
    },
    initAnimation: function initAnimation() {
      // 为数字增长添加入场动画
      var items = document.querySelectorAll('.stats-item');
      items.forEach(function (item, index) {
        setTimeout(function () {
          item.classList.add('show');
        }, index * 150);
      });
    },
    // 项目下拉
    getUserViewSelect: function () {
      var _getUserViewSelect = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _dashboard.fucardIntegralSelect)();
            case 1:
              res = _context.v;
              this.proJectList = res;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getUserViewSelect() {
        return _getUserViewSelect.apply(this, arguments);
      }
      return getUserViewSelect;
    }(),
    // 客户下拉
    handeGetAllCustomer: function () {
      var _handeGetAllCustomer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return customerOrderApi.getAllCustomer();
            case 1:
              res = _context2.v;
              // 接口会返回 { code, message, data } 结构，这里只取真正的列表数据
              this.customerList = Array.isArray(res) ? res : res && Array.isArray(res.data) ? res.data : [];
              this.setDefaultCustomer();
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handeGetAllCustomer() {
        return _handeGetAllCustomer.apply(this, arguments);
      }
      return handeGetAllCustomer;
    }(),
    // 小程序下拉
    handleCompanyappAutoListApi: function () {
      var _handleCompanyappAutoListApi = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return customerOrderApi.companyappAutoListApi();
            case 1:
              res = _context3.v;
              this.aotuList = res;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handleCompanyappAutoListApi() {
        return _handleCompanyappAutoListApi.apply(this, arguments);
      }
      return handleCompanyappAutoListApi;
    }(),
    // 设置默认的appId值
    setDefaultAppId: function setDefaultAppId() {
      var _this3 = this;
      if (this.defaultCustomerId && this.aotuList.length > 0) {
        // 在aotuList中查找与defaultCustomerId匹配的项
        console.log("this.aotuList", this.aotuList);
        console.log("defaultCustomerId", this.defaultCustomerId);
        var matchedItem = this.aotuList.find(function (item) {
          return item.customerId == _this3.defaultCustomerId;
        });
        if (matchedItem) {
          console.log("设置默认appId", matchedItem);
          this.appId = matchedItem.id;
        }
      }
    },
    // 设置默认客户
    setDefaultCustomer: function setDefaultCustomer() {
      var _this4 = this;
      if (!this.defaultCustomerId || !this.customerList.length) return;
      var match = this.customerList.find(function (item) {
        return Number(item.id) === Number(_this4.defaultCustomerId);
      });
      if (match) {
        this.customerId = match.id;
      }
    },
    getChannel: function getChannel() {
      var _this5 = this;
      this.chartLoading = true;
      (0, _dashboard.fucardUsedData)(this.getQueryParams()).then(function (res) {
        var tradeData = Array.isArray(res.tradeData) ? res.tradeData : [];
        var chartData = tradeData.map(function (item) {
          return {
            name: item.name || item.tradeName || item.channelName || '未命名',
            value: Number(item.integral) || 0
          };
        }).sort(function (a, b) {
          return b.value - a.value;
        });
        var totalValue = chartData.reduce(function (sum, cur) {
          return sum + cur.value;
        }, 0);
        var categories = chartData.map(function (item) {
          return item.name;
        });
        _this5.optionData = {
          color: _this5.colorList,
          grid: {
            left: '3%',
            right: 160,
            bottom: '3%',
            top: '8%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            },
            formatter: function formatter(params) {
              return _this5.formatBarTooltip(params, totalValue);
            },
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            borderColor: '#eee',
            borderWidth: 1,
            textStyle: {
              color: '#333'
            }
          },
          xAxis: {
            type: 'value',
            axisLabel: {
              formatter: function formatter(value) {
                return _this5.formatYuan(value, {
                  showUnit: false
                });
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          yAxis: {
            type: 'category',
            data: categories,
            axisTick: {
              show: false
            }
          },
          series: [{
            type: 'bar',
            data: chartData.map(function (item, index) {
              return {
                value: item.value,
                name: item.name,
                percent: totalValue ? (item.value / totalValue * 100).toFixed(2) : '0.00',
                itemStyle: {
                  color: _this5.colorList[index % _this5.colorList.length]
                }
              };
            }),
            barWidth: 18,
            itemStyle: {
              borderRadius: [0, 6, 6, 0]
            },
            label: {
              show: true,
              position: 'right',
              formatter: function formatter(_ref) {
                var data = _ref.data;
                return _this5.formatBarLabel(data);
              },
              color: '#333',
              backgroundColor: 'rgba(255,255,255,0.8)',
              padding: [2, 6],
              borderRadius: 4
            },
            labelLayout: {
              moveOverlap: 'shiftY',
              hideOverlap: true
            }
          }]
        };
      }).finally(function () {
        _this5.chartLoading = false;
      });
    },
    handleExport: function handleExport() {
      var _this6 = this;
      this.exportLoading = true;
      this.isExporting = true; // 显示导出中提示
      this.exportProgress = 0; // 重置导出进度
      this.exportProgressInteger = 0; // 重置整数进度

      // 模拟导出进度，更慢的进度
      var intervalId = setInterval(function () {
        // 根据当前进度设置不同的增长速度
        var increment = 0;
        if (_this6.exportProgress < 30) {
          increment = 5; // 开始阶段快一点
        } else if (_this6.exportProgress < 60) {
          increment = 3; // 中间阶段慢一点
        } else {
          increment = 2; // 后期非常慢
        }
        _this6.exportProgress += increment;
        if (_this6.exportProgress >= 85) {
          clearInterval(intervalId); // 停止进度模拟
          // 保持在85%，等待实际完成后设为100%
          _this6.exportProgress = 85;
          _this6.exportProgressInteger = 85;
        } else {
          // 更新整数进度，只在整数变化时更新，减少重渲染
          var newInteger = Math.round(_this6.exportProgress);
          if (newInteger !== _this6.exportProgressInteger) {
            _this6.exportProgressInteger = newInteger;
          }
        }
      }, 800); // 每800毫秒增加一次进度

      // 发起导出请求
      var exportParams = this.getQueryParams();
      (0, _dashboard.exportFudouUsageDetail)(exportParams).then(function (res) {
        clearInterval(intervalId); // 停止进度模拟
        // 使用Vue的nextTick确保DOM更新
        _this6.$nextTick(function () {
          _this6.exportProgress = 100; // 设置进度为100%
          _this6.exportProgressInteger = 100; // 设置整数进度为100%
        });
        setTimeout(function () {
          _this6.isExporting = false; // 延迟关闭对话框
          _this6.exportLoading = false;
          if (res && res.fileName) {
            window.open(res.fileName);
          }
        }, 1500);
      }).catch(function (error) {
        clearInterval(intervalId); // 停止进度模拟
        _this6.isExporting = false; // 隐藏导出中提示
        _this6.exportLoading = false;
        _this6.$message.error('导出请求失败: ' + (error.message || '未知错误'));
      });
    }
  },
  props: {
    miniProgramCustomer: {
      type: Boolean,
      default: false
    },
    defaultCustomerId: {
      type: Number,
      default: null
    }
  }
};